<template>
    <div id="AddCase">
        <HeaderBackend />
        <div class="banner">
            <img class="bg-img" src="@/assets/img/portfolio/portfolio_bg.png" alt="SURREAL 超現實科技" />
            <div class="content-area">
                <h1 class="content-title">精選案例</h1>
                <div class="split-line"></div>
            </div>
        </div>
        <div class="center-area">
            <div class="addportfolio-item"  @click="AddPortfolio()">
                <div class="item-photo-area">
                    <img class="item-photo" src="@/assets/img/portfolio/add.jpg" />
                    <div class="item-photo-hover">
                        <label class="photo-hover-text">
                        新增一筆空資料
                        </label>
                    </div>
                </div>
                <div class="item-client"></div>
                <div class="item-title"></div>
            </div>

            <div class="tool-type">
                <button :class="TypeClass(t.Type)" v-for="t in Types" :key="t.Type" @click="SwitchType(t.Type)">
                {{ t.Text }}
                </button>
            </div>
            <div class="portfolio-item" v-for="p in PortfolioList" :key="p.Serial" @click="PortfolioPageEdit(p.Serial)">
                <div class="item-photo-area">
                    <img class="item-photo" :src="p.PhotoUrl" />
                    <div class="item-photo-hover">
                        <label class="photo-hover-text">
                        {{ p.Desc.slice(0, 160) }}
                        </label>
                    </div>
                </div>
                <div class="item-client">{{ p.Client }}</div>
                <div class="item-title">{{ p.Title }}</div>
            </div>
            <div class="clear-both"></div>
            <PageControl :CurrentPage="CurrentPage" :MaxPage="MaxPage" @select-page="SelectPage" />
        </div>
        <Loading
            :active.sync="loadingInfo.isLoading"
            :can-cancel="false"
            :is-full-page="true"
            :color="loadingInfo.color"
            :opacity="loadingInfo.opacity"
            :background-color="loadingInfo.bgColor"
        ></Loading>
    </div>
</template>

<script>
  import PageControl from '@/components/pageControl/PageControl.vue';
  import HeaderBackend from '@/components/header/HeaderBackend.vue';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Loading from 'vue-loading-overlay';
  import { apiGetPortfolioType, apiGetPortfolioList , apiAddNewPortfolio} from '@/request.js';
  export default {
    mounted() {
        this.GetType();
        this.GetPortfolioList();
    },
    data() {
      return {
        Types: null,
        CurrentType: '',
        CurrentPage: 1,
        MaxPage: 0,
        PortfolioList: null,
        loadingInfo: {
            isLoading: false,
            color: '#fff',
            opacity: 0.9,
            bgColor: '#131217',
        },
      };
    },
    computed: {},
    methods: {
        TypeClass(Type) {
            return Type == this.CurrentType ? 'tool-type-select' : 'tool-type-unselect';
        },
        GetType() {
            const ltoken = sessionStorage.getItem('ltoken');
            if (ltoken) {
            // 已登入，可以進行相關操作
            } else {
            // 未登入，導向登入頁面
                this.$router.push({ path: '/Backend/Main' });
                this.ScrollTO('Header');
                return;
            }

            apiGetPortfolioType().then((res) => {
                if (res.data.Status == 'ok') {
                this.Types = res.data.Types;
                } else {
                this.$toasted.show(`Error:${res.data.Error}, Code:${res.data.Code}`, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                });
                }
            });
            // this.Types = [
            //   { Text: '全部', Type: '' },
            //   { Text: '行銷宣傳', Type: '1' },
            //   { Text: '科技教育', Type: '2' },
            //   { Text: '互動體驗', Type: '3' },
            // ];
        },
        SwitchType(Type) {
            this.CurrentType = Type;
            this.CurrentPage = 1;
            this.GetPortfolioList();
        },
        GetPortfolioList() {
            this.loadingInfo.isLoading = true;
            apiGetPortfolioList(this.CurrentType, this.CurrentPage).then((res) => {
                this.loadingInfo.isLoading = false;
                if (res.data.Status == 'ok') {
                    this.PortfolioList = res.data.PortfolioList;
                    this.MaxPage = res.data.MaxPage;
                } else {
                    this.$toasted.show(`Error:${res.data.Error}, Code:${res.data.Code}`, {
                        icon: 'warning',
                        position: 'bottom-center',
                        duration: 3500,
                    });
                }
            });
        },
        SelectPage(No){
            this.CurrentPage = No;
            this.GetPortfolioList();
            this.ScrollTO('Header');
        },
        PortfolioPageEdit(Serial) {
            this.$router.push({ path: `/backend/EditCase?s=${Serial}&t=${this.CurrentType}` });
            this.ScrollTO('Header');
        },
        AddPortfolio()
        {
            let data = {
                Login : "1"
            };

            let errMsg = 'test';
            apiAddNewPortfolio(data).then((res) => {
                let resp = res.data;
                if (resp.Status == 'ok') {
                    errMsg = resp.Serial;

                    this.$router.push({ path: `/Backend/EditCase?s=${resp.Serial}`} )
                }

                this.$toasted.show(errMsg, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
            });
        }
    },
    components: { HeaderBackend , PageControl , Loading },
  };
  </script>